import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=90b181bc&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90b181bc')) {
      api.createRecord('90b181bc', component.options)
    } else {
      api.reload('90b181bc', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=90b181bc&", function () {
      api.rerender('90b181bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2j5GmkMgYfn87/JS/imageCarousel.vue"
export default component.exports